import {BASE_URL, baseGetData, basePostData} from "./BaseApi";


// events
export const getLastEventApi = async () => {
    return baseGetData(`${BASE_URL}/api/users/event/last`)
}
export const getEventListApi = async ({page = 1, limit = 10, query = '', plan_id}) => {
    return baseGetData(`${BASE_URL}/api/users/event/list?page=${page}&limit=${limit}&query=${query}&plan_id=${plan_id}`)
}
export const getEventInfoApi = async (event_id) => {
    return baseGetData(`${BASE_URL}/api/users/event/info?event_id=${event_id}`)
}

// plans
export const getPlanListApi = async () => {
    return baseGetData(`${BASE_URL}/api/users/plan/list`)
}
export const getPlanInfoApi = async (plan_id) => {
    return baseGetData(`${BASE_URL}/api/users/plan/info?plan_id=${plan_id}`)
}

// subscribe
export const subscribeUserApi = async (data = {}) => {
    return basePostData(BASE_URL + '/api/users/subscribe', JSON.stringify(data));
}
// customer
export const getCustomerListApi = async (page = 1, limit = 10) => {
    return baseGetData(`${BASE_URL}/api/users/customer/list?page=${page}&limit=${limit}`)
}

// about
export const getAboutInfoApi = async () => {
    return baseGetData(`${BASE_URL}/api/users/about/info`)
}
// target of us
export const getVisionInfoApi = async () => {
    return baseGetData(`${BASE_URL}/api/users/vision/info`)
}

// tickets
export const PostNewTicketApi = async (data = {}) => {
    return basePostData(BASE_URL + '/api/users/ticket/post', JSON.stringify(data));
}
